<template>
  <div>
    <mt-header :title="$t('绑定手机号')">
      <mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
    </mt-header>
    <div class="form">
      <mt-cell class="form-item" :title="$t('区号')" :value="areacode" @click.native="popupVisible = true" is-link>
        <span class="areatitle" v-if="!areacode">{{
          $t("请选择区号")
        }}</span></mt-cell>
      <mt-field class="form-item" :label="$t('手机号')" :placeholder="$t('请输入手机号')" v-model.trim="mobile"></mt-field>
      <mt-field class="form-item" :label="$t('验证码')" :placeholder="$t('请输入验证码')" v-model.trim="verification_code">
        <mt-button v-if="count === 60" size="small" @click="getCode">{{
          $t("获取验证码")
        }}</mt-button>
        <div v-else>{{ count }} s</div>
      </mt-field>
      <div style="padding: 20px">
        <mt-button block size="large" type="primary" @click="onBind">{{
          $t("绑定")
        }}</mt-button>
      </div>
    </div>
    <mt-popup v-model="popupVisible" position="bottom">
      <select-area @onChange="onChangeArea" />
    </mt-popup>
    <VerifyPopup ref="refVerify" scene="credentials_bind_mobile" @onVerify="onSubmit" />
    <ImageVerify scene="bind_mobile" :username="`${areacode}-${mobile}`" ref="imageverify" @imageCallback="imageCallback">
    </ImageVerify>
  </div>
</template>

<script>
import SelectArea from "@/components/SelectArea";
import VerifyPopup from "@/components/VerifyPopup";
import ImageVerify from "@/components/ImageVerify.vue";
import { Toast } from "mint-ui";
import { httpGetCode, httpBindMobile } from "@/api/userCenter";
import { httpGetUserInfo } from "@/api/login";
export default {
  components: { SelectArea, VerifyPopup, ImageVerify },
  data() {
    return {
      popupVisible: false,
      areacode: "",
      count: 60,
      mobile: "",
      verification_code: "",
    };
  },
  activated() {
    this.popupVisible = false;
    this.count = 60;
    this.mobile = "";
    this.verification_code = "";
    this.areacode = "";
    this.credentials = "";
  },
  methods: {
    countDown() {
      if (this.count === 0) {
        this.count = 60;
        return;
      }
      this.count--;
      setTimeout(() => {
        this.countDown();
      }, 1000);
    },
    onChangeArea(value) {
      this.popupVisible = false;
      this.areacode = value;
    },
    getCode() {
      if (this.mobile == "") {
        Toast(this.$t("请输入手机号"));
        return;
      }
      this.$refs.imageverify.run()
      // httpGetCode({
      //   username: `${this.areacode}-${this.mobile}`,
      //   scene: "bind_mobile",
      // }).then(({ msg }) => {
      //   Toast(msg);
      //   this.countDown();
      // });
    },

    imageCallback() {

      this.countDown();
    },
    onBind() {
      if (this.areacode === "") {
        Toast(this.$t("请选择区号"));
        return;
      }

      if (this.mobile === "") {
        Toast(this.$t("请输入手机号"));
        return;
      }
      if (this.verification_code == "") {
        Toast(this.$t("请输入验证码"));
        return;
      }
      if (this.credentials) {
        this.onSubmit(this.credentials);
      } else {
        this.$refs.refVerify.show = true;
      }
    },
    onSubmit(credentials) {
      this.credentials = credentials;
      const payload = {
        mobile: this.areacode + "-" + this.mobile,
        verification_code: this.verification_code,
      };
      if (parseInt(Date.now() / 1000) > credentials.expiretime) {
        this.$refs.refVerify.show = true;
        return false;
      } else {
        payload.credentials = credentials.credentials;
      }
      httpBindMobile(payload).then(({ msg }) => {
        Toast(msg);
        httpGetUserInfo();
        this.$router.back();
      });
    },
  },
};
</script>

<style scoped>
.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}

.form-item {
  border-bottom: 1px solid #f6f6f6;
}

.areatitle {
  font-size: inherit;
  color: #cfd9de;
}
</style>
